export const moveElementInArray = (arr = [], old_index, new_index) => {
  const clonedArray = [...arr]
  if (new_index >= clonedArray.length) {
    let k = new_index - clonedArray.length + 1
    while (k--) {
      clonedArray.push(undefined)
    }
  }
  clonedArray.splice(new_index, 0, clonedArray.splice(old_index, 1)[0])
  return clonedArray
}